// 环境配置
export interface EnvConfig {
  // 应用基础配置
  APP_TITLE: string;
  APP_VERSION: string;

  // API 配置
  API_BASE_URL: string;
  API_TIMEOUT: number;

  // 登录相关配置
  LOGIN_URL: string;

  // 系统类型配置
  SYSTEM_TYPE: 'business' | 'agent' | null;

  // 其他配置
  ENABLE_MOCK: boolean;
  ENABLE_DEVTOOLS: boolean;
}

// 开发环境配置
const developmentConfig: EnvConfig = {
  APP_TITLE: '员工管理系统 - 开发环境',
  APP_VERSION: '1.0.0-dev',
  API_BASE_URL: 'https://id-test.linccareer.com/lincid',
  API_TIMEOUT: 30000,
  LOGIN_URL: '/login',
  SYSTEM_TYPE: null,
  ENABLE_MOCK: false,
  ENABLE_DEVTOOLS: true,
};

// 测试环境配置
const testConfig: EnvConfig = {
  APP_TITLE: '员工管理系统 - 测试环境',
  APP_VERSION: '1.0.0-test',
  API_BASE_URL: 'https://id-test.linccareer.com/lincid',
  // API_BASE_URL: 'https://staging.api.id.linccareer.com',
  API_TIMEOUT: 30000,
  LOGIN_URL: '/login',
  SYSTEM_TYPE: null,
  ENABLE_MOCK: false,
  ENABLE_DEVTOOLS: true,
};

// 灰度环境配置
const stagingConfig: EnvConfig = {
  APP_TITLE: '员工管理系统 - 灰度环境',
  APP_VERSION: '1.0.0-staging',
  API_BASE_URL: 'https://staging.api.id.linccareer.com',
  API_TIMEOUT: 30000,
  LOGIN_URL: '/login',
  SYSTEM_TYPE: null,
  ENABLE_MOCK: false,
  ENABLE_DEVTOOLS: false,
};

// 生产环境配置
const productionConfig: EnvConfig = {
  APP_TITLE: '员工管理系统',
  APP_VERSION: '1.0.0',
  API_BASE_URL: 'https://api.id.linccareer.com',
  API_TIMEOUT: 30000,
  LOGIN_URL: '/login',
  SYSTEM_TYPE: null,
  ENABLE_MOCK: false,
  ENABLE_DEVTOOLS: false,
};

// 获取当前环境配置
export function getEnvConfig(): EnvConfig {
  // 获取环境变量中的系统类型
  const systemType = import.meta.env.VITE_SYSTEM_TYPE as 'business' | 'agent' | undefined;

  // 优先使用环境变量中的配置
  if (import.meta.env.VITE_APP_BASE_URL) {
    return {
      APP_TITLE: import.meta.env.VITE_APP_TITLE || '员工管理系统',
      APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
      API_BASE_URL: import.meta.env.VITE_APP_BASE_URL,
      API_TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
      LOGIN_URL: import.meta.env.VITE_LOGIN_URL || '/login',
      SYSTEM_TYPE: systemType || null,
      ENABLE_MOCK: import.meta.env.VITE_ENABLE_MOCK === 'true',
      ENABLE_DEVTOOLS: import.meta.env.VITE_ENABLE_DEVTOOLS === 'true',
    };
  }

  // 根据环境变量选择配置
  const env = import.meta.env.MODE || 'development';
  console.log('当前接口环境：', env)
  let config: EnvConfig;

  switch (env) {
    case 'development':
      config = developmentConfig;
      break;
    case 'test':
      config = testConfig;
      break;
    case 'staging':
      config = stagingConfig;
      break;
    case 'production':
      config = productionConfig;
      break;
    default:
      config = developmentConfig;
  }

  // 如果有 VITE_SYSTEM_TYPE 环境变量，覆盖配置中的 SYSTEM_TYPE
  if (systemType) {
    console.log('📌 通过环境变量设置系统类型:', systemType);
  }

  return {
    ...config,
    SYSTEM_TYPE: systemType || config.SYSTEM_TYPE
  };
}

// 导出当前环境配置
export const ENV_CONFIG = getEnvConfig();

// 环境判断工具函数
export const isDevelopment = () => import.meta.env.MODE === 'development';
export const isTest = () => import.meta.env.MODE === 'test';
export const isStaging = () => import.meta.env.MODE === 'staging';
export const isProduction = () => import.meta.env.MODE === 'production';

// 获取系统类型（从环境变量或配置中）
export const getSystemType = (): 'business' | 'agent' | null => {
  return import.meta.env.VITE_SYSTEM_TYPE;
};
